import { LogoutButton } from 'components/account/buttons';

import Container from 'components/container';
import { BuildData } from 'components/footer';
import Anchor from 'components/typography/anchor';
import bluesky from 'images/icons/bluesky.svg';
import discord from 'images/icons/discord.svg';
import instagram from 'images/icons/instagram.svg';
import messenger from 'images/icons/messenger.svg';
import telegram from 'images/icons/telegram.svg';
import threads from 'images/icons/threads.svg';
import Img from 'next/image';
import config from 'siteconfig';

const Footer = () => {
  return (
    <footer
      role="contentinfo"
      className="bg-stone-50 bg-(image:--bg-footer) bg-cover bg-center py-10 dark:bg-stone-950 dark:bg-blend-hard-light print:hidden"
    >
      <Container>
        <nav className="mb-4 grid w-auto grid-cols-2 gap-x-4 sm:grid-cols-3 md:grid-cols-4">
          <Anchor className="anchor-nav" href="/">
            Home
          </Anchor>
          <Anchor className="anchor-nav" href="/chat">
            Chat
          </Anchor>
          <Anchor className="anchor-nav" href="/premium">
            Membership
          </Anchor>
          <Anchor className="anchor-nav" href="/premium/coins">
            Buy Coins
          </Anchor>
          <Anchor className="anchor-nav" href="/guide">
            Guide
          </Anchor>
          <Anchor className="anchor-nav" href="/petitions">
            Petitions
          </Anchor>
          <Anchor className="anchor-nav" href="/letters">
            Open Letters
          </Anchor>
          <Anchor className="anchor-nav" href="/officials">
            Officials
          </Anchor>
          <Anchor
            className="anchor-nav"
            href={`https://amendment.app/oversight`}
          >
            Legislation
          </Anchor>
          <Anchor className="anchor-nav" href={config.shopUrls.cottonBureau}>
            Shop
          </Anchor>
          <Anchor className="anchor-nav" href="/about">
            Help
          </Anchor>
          <Anchor className="anchor-nav" href={`/${config.blog.baseURL}`}>
            News
          </Anchor>
          <LogoutButton style={'text'} />
        </nav>
        <p className="mb-4 text-sm">
          Resistbot is a free service, but message and data rates may apply if
          you use the service over SMS. Message frequency varies. Text STOP to
          50409 to stop all messages. Text HELP to 50409 for help. Here are our{' '}
          <Anchor className="anchor-nav" href="/terms">
            terms&nbsp;of&nbsp;use
          </Anchor>
          ,{' '}
          <Anchor className="anchor-nav" href="/privacy">
            privacy&nbsp;notice
          </Anchor>{' '}
          and{' '}
          <Anchor className="anchor-nav" href="/rights">
            user bill of&nbsp;rights
          </Anchor>
          .
        </p>
        <p className="mb-4 text-sm">
          Resistbot is built by{' '}
          <Anchor className="anchor-nav" href={config.miscUrls.governance}>
            The Governance Company
          </Anchor>{' '}
          for the Resistbot Action Fund, a 501(c)(4) social welfare
          organization. Since we lobby on your behalf, donations are not
          tax-deductible as charitable contributions.
        </p>
        <section className="mb-6 flex size-fit flex-wrap items-center">
          <Anchor
            href={`${config.channelUrls.telegram}resist`}
            className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
          >
            <Img
              src={telegram}
              alt="Telegram"
              height="20"
              width="20"
              className="h-4 dark:invert"
            />
          </Anchor>
          <Anchor
            href={`${config.channelUrls.messenger}resist`}
            className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
          >
            <Img
              src={messenger}
              alt="Messenger"
              height="20"
              width="20"
              className="h-4 dark:invert"
            />
          </Anchor>
          <Anchor
            href={config.socialUrls.bluesky}
            className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
          >
            <Img
              src={bluesky}
              alt="Bluesky"
              height="20"
              width="20"
              className="h-4 dark:invert"
            />
          </Anchor>
          <Anchor
            href={`${config.channelUrls.instagram}resist`}
            className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
          >
            <Img
              src={instagram}
              alt="Instagram"
              height="20"
              width="20"
              className="h-4 dark:invert"
            />
          </Anchor>
          <Anchor
            href={config.socialUrls.threads}
            className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
          >
            <Img
              src={threads}
              alt="Threads"
              height="20"
              width="20"
              className="h-4 dark:invert"
            />
          </Anchor>
          <Anchor
            href={config.socialUrls.discord}
            className="p-3.5 opacity-30 transition-opacity hover:opacity-80"
          >
            <Img
              src={discord}
              alt="Discord"
              height="20"
              width="20"
              className="h-4 dark:invert"
            />
          </Anchor>
        </section>
        <BuildData />
      </Container>
    </footer>
  );
};

export default Footer;
